import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {PostPayloadInterface} from "../models/post-payload.interface";
import {ApiUri, BaseApiUri, BaseRepository, HellpositoryConfig} from "hellpository";
import {GetPayloadInterface} from "../models/get-payload.interface";


@BaseApiUri('dashboard/staff/reservations')
@Injectable({
  providedIn: 'root'
})
export class ReservationRepository extends BaseRepository<PostPayloadInterface> {

  constructor(public httpClient: HttpClient, public hellpConfig: HellpositoryConfig) {
    super(httpClient, hellpConfig);
  }

  @ApiUri('/{reservationNumber}/decrement-person-count')
  decrementRestaurantReservationPersonCount(reservationNumber: string, payload: PostPayloadInterface) {
    return super.patch(payload);
  }

  @ApiUri('/{id}/success')
  success(id: number) {
    return super.patch();
  }

  @ApiUri('/{id}/not-arrived')
  notArrived(id: number) {
    return super.patch();
  }

  @ApiUri('/guests')
  saveGuestsToReservation(payload) {
    return super.patch(payload);
  }

  @ApiUri('/new')
  getAllByFilter(filter: GetPayloadInterface) {
    const options = {params: new HttpParams().append('filter', JSON.stringify(filter))};
    return super.get(options);
  }

  @ApiUri('/daily-sum/PERSONAL/{restaurantHistoryId}?date={date}')
  getDailySum(restaurantHistoryId, date) {
    return super.get();
  }

  @ApiUri('/guest/add')
  saveNewGuestWithDiy(payload: PostPayloadInterface) {
    return super.post(payload);
  }

  @ApiUri('/guest/{guestId}/add-diy/{diyId}')
  addNewDiyToGuest(guestId: number, diyId: number) {
    return super.patch();
  }

  @ApiUri('/guest/{guestId}/add-diy/{diyId}')
  deleteDiyFromGuest(guestId: number, diyId: number) {
    return super.delete();
  }

}
